import React from "react";

interface SectorData {
  sector_id: number;
  sector_name: string;
  sector_code: string;
  company_count: number;
  avg_day_change: number;
  bullish_signals: number;
  bearish_signals: number;
  neutral_signals: number;
}

interface SectorPerformanceProps {
  sectors?: SectorData[] | null; 
}

const SectorPerformance: React.FC<SectorPerformanceProps> = ({
  sectors = [], 
}) => {
 
  const safeSectors: SectorData[] = Array.isArray(sectors) ? sectors : [];

  const sortedSectors = [...safeSectors].sort(
    (a, b) => b.avg_day_change - a.avg_day_change
  );

  return (
    <div className="box sector-performance">
      <h2 className="title is-5 mb-4">
        <span className="icon">
          <i className="fa fa-industry"></i>
        </span>
        <span>Sector Performance</span>
      </h2>

      {sortedSectors.length === 0 ? (
        <div className="notification is-light has-text-centered">
          <p>No sector data available</p>
        </div>
      ) : (
        <div className="sector-list">
          {sortedSectors.map((sector) => (
            <div key={sector.sector_id} className="sector-item mb-3 pb-3">
              <div className="level is-mobile mb-2">
                <div className="level-left">
                  <div className="level-item">
                    <div>
                      <p className="has-text-weight-bold">
                        {sector.sector_name}
                      </p>
                      <p className="is-size-7 has-text-grey">
                        {sector.company_count} companies
                      </p>
                    </div>
                  </div>
                </div>

                <div className="level-right">
                  <div className="level-item">
                    <span
                      className={`tag is-medium ${
                        sector.avg_day_change >= 0
                          ? "is-success"
                          : "is-danger"
                      }`}
                    >
                      {sector.avg_day_change >= 0 ? "+" : ""}
                      {sector.avg_day_change.toFixed(2)}%
                    </span>
                  </div>
                </div>
              </div>

              <div className="level is-mobile">
                <div className="level-left">
                  <div className="level-item">
                    <div className="tags">
                      <span className="tag is-success is-light">
                        <i className="fa fa-arrow-up mr-1"></i>
                        {sector.bullish_signals}
                      </span>

                      <span className="tag is-danger is-light">
                        <i className="fa fa-arrow-down mr-1"></i>
                        {sector.bearish_signals}
                      </span>

                      <span className="tag is-warning is-light">
                        <i className="fa fa-minus mr-1"></i>
                        {sector.neutral_signals}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <progress
                className={`progress is-small ${
                  sector.avg_day_change >= 2
                    ? "is-success"
                    : sector.avg_day_change >= 0
                    ? "is-info"
                    : sector.avg_day_change >= -2
                    ? "is-warning"
                    : "is-danger"
                }`}
                value={Math.abs(sector.avg_day_change)}
                max={5}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SectorPerformance;
